import React from 'react';
import { getIsMobile } from '../../common/store/base-params/base-params-selectors';
import { useApi } from '../context/api-context/use-api';
import { useConfiguration } from '../context/configuration-context/use-configuration';
const forDevice = (MobileComponent, DesktopComponent, { forceDesktopWhenInlineMobile } = {}) => ({ ...props }) => {
    const isMobile = useApi((state) => getIsMobile(state));
    const { _useInlineMobile } = useConfiguration();
    const Component = !isMobile || (forceDesktopWhenInlineMobile && _useInlineMobile)
        ? DesktopComponent
        : MobileComponent;
    return React.createElement(Component, { ...props });
};
export default forDevice;
//# sourceMappingURL=for-device.js.map